export default __webpack_public_path__ + "static/media/ROC-1.193f1826.jpg";